import {
  READY_CHANGE_INTELLIGENCE_TYPE
} from '../actions/timeRangeIntelligenceType'

const initialState = {}

const timeRangeIntelligenceTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case READY_CHANGE_INTELLIGENCE_TYPE:
      return Object.assign(
        {},
        state, 
        {
          intelligenceType: action.data
        }
      )
    default:
      return state
  }
}

export default timeRangeIntelligenceTypeReducer